module.exports = __webpack_public_path__ + "static/media/team_02.6fcd82c7.jpg";